import React from 'react';
import SearchForm from './SearchForm';

export default function Hero() {
  return (
    <div className="mt-16 max-w-2xl mx-auto"> 
          <div className='text-center'>
        <h1 className="text-4xl font-bold lg:text-6xl text-gray-800 leading-tight">
          Let's run your tasks, <span className="text-purple-500">Hitmeup!</span>
        </h1>
        <p className="mt-4 text-lg text-gray-600 lg:text-xl max-w-2xl mx-auto"> 
          Need a hand? Find help for any task — fast and easy.
        </p>
        <div className="mt-8">
          <SearchForm />
        </div>
      </div>
    </div>
  );
}
